import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  extraConfigProducts,
  getProductById,
} from '../components/v3/helpers/store';

type ShootProduct = Record<string, any>;

// Resolves the product id in the current route (/v3/products-regular/:id)
// against shootProducts first, falling back to suggestedProducts /
// additionalOfferProducts — products configurable at their own price that
// are NOT part of shootProducts (see SuggestedProducts/AdditionalOffers).
// Returns null when the id resolves nowhere.
const useCurrentProduct = (): ShootProduct | null => {
  const { id: productId } = useParams<{ id: string }>();
  const shoot = useSelector((state: any) => state.shoot);

  try {
    return getProductById(
      shoot.shootProducts,
      productId,
      extraConfigProducts(shoot),
    );
  } catch (e) {
    return null;
  }
};

export default useCurrentProduct;
